import { Send01 } from "@untitledui/icons"
import type { FormEvent, HTMLAttributes } from "react"

import { Button } from "@/components/base/buttons/button"
import { InputBase } from "@/components/base/input/input"
import { cx } from "@/utils/cx"

export interface MessageActionMinimalProps
  extends Omit<HTMLAttributes<HTMLFormElement>, "onSubmit"> {
  onSubmit?: (message: string) => void
}

export const MessageActionMinimal = ({
  onSubmit,
  className,
  ...props
}: MessageActionMinimalProps) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    const message = formData.get("message") as string
    onSubmit?.(message)
  }

  return (
    <form
      className={cx("flex h-max w-90 items-center gap-3", className)}
      onSubmit={handleSubmit}
      {...props}
    >
      <InputBase
        aria-label="Message"
        size="md"
        placeholder="Message"
        name="message"
      />

      <Button type="submit" size="lg" color="secondary" iconLeading={Send01} />
    </form>
  )
}
